import Svg, { Path } from "react-native-svg";
import { GetProps } from "tamagui";

const FilesIcon = ({ color, ...props }: GetProps<typeof Svg>) => (
  <Svg width="24" height="24" viewBox="0 0 22 24" fill="none" {...props}>
    <Path
      d="M19 4L19 18.5C19 19.3284 18.3284 20 17.5 20L4 20M22 6L22 21.5C22 22.3284 21.3284 23 20.5 23L6 23M7.65656 1L7.65656 6.49333C7.65656 6.55224 7.6088 6.59999 7.54989 6.59999L2 6.59999M2 6.59999L2 6.26002C2 5.97631 2.11302 5.70429 2.31407 5.50412L6.52582 1.31077C6.72573 1.11174 6.99633 1 7.27842 1L7.65656 1L14.9333 1.00002C15.5224 1.00002 16 1.47758 16 2.06668L16 15.9333C16 16.5224 15.5224 17 14.9333 17L3.06667 17C2.47756 17 2 16.5224 2 15.9333L2 6.59999Z"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </Svg>
);

export default FilesIcon;
